export default "__VITE_ASSET__iSgeB3PE__"